module.exports = __webpack_public_path__ + "img/hoora.0a014f43.svg";